const SET_ACTIVE_TIMEOUT_MS = 8_000;

export const setActiveWithTimeout = (
  setActive: (params: { organization: string }) => Promise<unknown>,
  orgSlug: string,
): Promise<void> =>
  new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('Organization switch timed out'));
    }, SET_ACTIVE_TIMEOUT_MS);

    setActive({ organization: orgSlug })
      .then(() => {
        clearTimeout(timer);
        resolve();
      })
      .catch((error) => {
        clearTimeout(timer);
        reject(error);
      });
  });
